import React from "react";
import { Box, Button, Text, Separator } from "@showitinc/showit-wc";

export const AddAction = ({ onAddAction, isLocked }) => (
  <Box d="flex" justify="center" align="center" mb="1" mt="3" pr="1">
    <Button
      iconPrefix="add"
      iconSize="20"
      variant="minimal"
      onClick={onAddAction}
      disabled={isLocked}
    >
      Action
    </Button>
  </Box>
);

export const Action = ({ children, onRemoveAction, index, last, isLocked }) => (
  <Box>
    <Box d="flex" justify="between" align="center">
      <Text className="panel-subheading">Action {index + 1}</Text>
      <Button
        iconPrefix="close"
        iconSize="20"
        variant="icon"
        onClick={onRemoveAction}
        disabled={isLocked}
      />
    </Box>
    {children}
    {!last && <Separator />}
  </Box>
);
